export enum LANG {
  EN = 'en',
  HE = 'he',
  AR = 'ar',
}
